import React from "react";
import ConfirmationModal from "app/components/common/ConfirmationModal";

const DeleteTemplateConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  isLoading,
}) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title="Delete Section Template?"
      confirmLabel="Delete"
      confirmVariant="danger"
      isLoading={isLoading}
      loadingLabel="Deleting..."
      className="delete-template-modal-wrapper"
    >
      <div className="mb-3">
        <ul>
          <li>This action cannot be undone.</li>
          <li>Make sure you no longer need this Section Template.</li>
          <li>
            Deleting a Section Template won't affect your existing projects
            or reports.
          </li>
        </ul>
      </div>
    </ConfirmationModal>
  );
};

export default DeleteTemplateConfirmationModal;
